import ContactMailIcon from '@mui/icons-material/ContactMail';
import CustomerContactList from './CustomerContactList';

export default {
  list: CustomerContactList,
  icon: ContactMailIcon,
};
